<template>
  <portlet
      :icon="'fad fa-flask'"
      id="statistics-header"
      :title="'Statistieken'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <button class="btn btn-primary" @click="printPage()">
        <i class="fas fa-print mr-2"></i> Afdrukken
      </button>
    </template>
    <template slot="portletBody">
      <div id="printarea">
        <h1 class="print-header">Statistieken: {{ customer.name }}</h1>
        <div class="filters">
          <div class="col-md-4 form-group">
            <label for="candidateAppointment-range">Bereik:</label><br/>
            <h6 >Week {{ picker.startDate.isoWeek() }}, {{ picker.startDate.isoWeekYear() }} t/m week {{ picker.endDate.isoWeek() }}, {{ picker.endDate.isoWeekYear() }}</h6>
            <date-range-picker
                id="candidateAppointment-range"
                ref="picker"
                v-model="picker"
                opens="center"
                :showDropdowns="true"
                :autoApply="true"
                :lang="nl"
                :locale-data="locales"
                :ranges="ranges"
                @update="updateDateRange"
            />
          </div>
        </div>
        <div class="gauges" v-if="getCustomerStatistics.length !== 0">
          <div id="sickdays-chart">
            <VueApexCharts type="radialBar" height="350" :options="getChartOptions('sickdays')"
                           :series="[this.floatToPercent(averageSicknessPerPlacing)]"></VueApexCharts>
          </div>
          <div id="duration-chart">
            <VueApexCharts type="radialBar" height="350" :options="getChartOptions('duration')"
                           :series="[75]"></VueApexCharts>
          </div>
          <div id="worked-hours-chart">
            <VueApexCharts type="radialBar" height="350" :options="getChartOptions('workedHours')"
                           :series="[this.floatToPercent(averagePlacementInHoursPercentage)]"></VueApexCharts>
          </div>
        </div>
        <div class="table-responsive vacancy-info">
          <table class="table dataTable table-bordered table-striped"
                 v-if="getCustomerStatistics.length !== 0">
            <thead>
            <tr>
              <th>Persoon</th>
              <th>Salaris (p/u)</th>
              <th>Begin datum</th>
              <th>Einddatum</th>
              <th>Duur</th>
              <th>Pensioen</th>
              <th>Ziek</th>
              <th>% Ziek</th>
              <th>Uren gewerkt</th>
              <th>Te werken uren</th>
              <th>% Gewerkt</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(placement, index) in getCustomerStatistics" :key="placement.id">
              <td>
                <router-link v-if="getCandidate(placement.candidateId)" :to="'/candidates/'+ placement.candidateId">{{ getFullName(placement.candidateId) }}
                </router-link>
                <span v-else>Verwijderde kandidaat</span>
              </td>
              <td>€ {{ placement.hourlyWage }}</td>
              <td>{{ placement.startDate|day }}</td>
              <td>
                <template v-if="placement.endDate">{{ placement.endDate|day }}</template>
                <template v-else></template>
              </td>
              <td>{{ placement.duration }}
                {{ placement.duration === null ? 'Nog niet gestart' : (placement.duration !== 1 ? 'dagen' : 'dag') }}
              </td>
              <td>{{ placement.retirement }}</td>
              <td>{{ placement.numberOfSickdays }} {{ placement.numberOfSickdays !== 1 ? 'dagen' : 'dag' }}</td>
              <td>{{ placement.sickVsPlaced | floatToPercentFilter }}%</td>
              <td>{{ placement.workedHours.hasWorked }}</td>
              <td>{{ placement.workedHours.shouldHaveWorked }}</td>
              <td>{{
                  (placement.workedHours.hasWorked / placement.workedHours.shouldHaveWorked) | floatToPercentFilter
                }}%
              </td>
            </tr>
            </tbody>
          </table>
          <div v-else>
            Geen plaatsingen gevonden. Controleer de datumfilter.
          </div>
        </div>
      </div>
    </template>
  </portlet>
</template>


<script>
import {mapGetters} from "vuex";
import VueApexCharts from 'vue-apexcharts'
import {nl} from "vuejs-datepicker/dist/locale";

export default {
  props: ["customer", "candidate"],
  components: {VueApexCharts},
  data() {
    return {
      nl: nl,
      ranges: {
        'Laatste 6 maanden': [moment().subtract(2, 'weeks').subtract(6, 'months').startOf('isoWeek'), moment().subtract(2, 'weeks').endOf('isoWeek')],
        'Volledige historie': [moment('01-01-2019').startOf('isoWeek'), moment().endOf('isoWeek')]
      },
      picker: {
        startDate: moment().subtract(2, 'weeks').subtract(6, 'months').startOf('isoWeek'),
        endDate: moment().subtract(2, 'weeks').endOf('isoWeek')
      },
      locales: {
        direction: 'ltr',
        format: moment.localeData('nl').longDateFormat('L'),
        separator: ' - ',
        applyLabel: 'Opslaan',
        cancelLabel: 'Annuleren',
        weekLabel: 'W',
        customRangeLabel: 'Bereik afspraken',
        daysOfWeek: moment.localeData('nl').weekdaysMin(),
        monthNames: moment.localeData('nl').monthsShort(),
        firstDay: moment.localeData('nl').firstDayOfWeek()
      },
      sickDays: [],
      placedCandidates: [],
      placement: "",
      sickdaysToLoad: 0,
      averagePlacementInDays: 0,
      averageSicknessPerPlacing: 0,
      averagePlacementInHoursActualValue: 0,
      averagePlacementInHoursPercentage: 0
    };
  },
  filters: {
    floatToPercentFilter(float) {
      const procent = Math.round(float * 100)
      return isFinite(procent) ? procent : 0;
    }
  },
  methods: {
    updateDateRange(dateRange) {
      const startDate = moment(dateRange.startDate);
      const endDate = moment(dateRange.endDate);
      // Force to start and end of isoweek
      this.picker.startDate = startDate.clone().startOf('isoWeek');
      this.picker.endDate = endDate.clone().endOf('isoWeek');
      this.$toasted.global.info({
        message: `Geselecteerd: 'week ${startDate.isoWeek()} ${startDate.isoWeekYear()}' tm 'week ${endDate.isoWeek()} ${endDate.isoWeekYear()}'`
      });


      //.startDate .endDate
      console.log("RANGE", dateRange);
    },
    printPage() {
      window.print();
    },
    floatToPercent(float) {
      return Math.round(float * 100)
    },
    getChartOptions(type) {
      return {
        chart: {
          height: 275,
          type: 'radialBar',
        },
        fill: {
          colors: ['#25b7bc']
        },
        plotOptions: {
          radialBar: {
            rawValue: this.getRawValue(type),
            startAngle: -135,
            endAngle: 135,
            hollow: {
              size: '70%',
            },
            dataLabels: {
              value: {
                show: true,
                fontSize: '14px',
                formatter: function (val, a, c) {
                  if (type === 'sickdays') {
                    return `${Math.round(val * 100) / 100}%`
                  } else if (type === 'duration') {
                    const days = Math.round(a.config.plotOptions.radialBar.rawValue);
                    return `${days} ${days !== 1 ? 'dagen' : 'dag'}`
                  } else if (type === 'workedHours') {
                    const hours = Math.round(a.config.plotOptions.radialBar.rawValue.actual);
                    const percentage = Math.round(a.config.plotOptions.radialBar.rawValue.percentage * 100);
                    return `${hours} ${hours !== 1 ? 'uren' : 'uur'} (${percentage}%)`
                  }
                }
              }
            }
          },
        },
        labels: [this.getChartLabel(type)],
      };
    },
    getChartLabel(type) {
      if (type === 'sickdays') {
        return 'Gemiddelde ziekte';
      } else if (type === 'duration') {
        return 'Gemiddelde plaatsing';
      } else if (type === 'workedHours') {
        return 'Gewerkte uren';
      } else {
        return ''
      }
    },
    getRawValue(type) {
      if (type === 'sickdays') {
        return this.averageSicknessPerPlacing;
      } else if (type === 'duration') {
        return this.averagePlacementInDays;
      } else if (type === 'workedHours') {
        return {
          actual: this.averagePlacementInHoursActualValue,
          percentage: this.averagePlacementInHoursPercentage
        };
      } else {
        return ''
      }
    },
    valueToPercent(value) {
      return (value * 100) / (value * 1.14)
    },
    async getSickDay(candidateId) {
      this.sickdaysToLoad++;
      // Get the sickdays of a candidate by id
      // Because its a sub collection it needs to go this way
      return new Promise(async (resolve) => {
        const sickDays = (await this.$FB.collection('candidates').doc(candidateId).collection('sickDays').get()).docs.map(doc => {
          return doc.data()
        });
        this.sickdaysToLoad--;
        resolve({
          candidateId,
          sickDays
        })
      })
    },
    rowSelected(value) {
      this.modalId = value.id;
      this.placement = {id: this.modalId, name: value.name, standard: value.standard};
    },
    getFullName(id) {
      const candidate = this.getCandidate(id);
      return candidate ? candidate.firstName + ' ' + candidate.lastName : 'Verwijderde kandidaat';
    }
  },
  computed: {
    ...mapGetters("placements", ["getCustomerPlacements"]),
    ...mapGetters("candidates", ["getCandidate"]),
    ...mapGetters("workedHours", ["getWorkedHours", "getWorkedHoursOfPlacementId"]),
    ...mapGetters("vacancies", ["getVacancyName"]),
    getSickDaysOfPlacement: (vue) => (candidateId, placementEndDate, placementStartDate) => {
      let sickdays = [];
      // First find the sickday of the candidate
      const sickDaysCollection = _.find(vue.sickDays, {'candidateId': candidateId});
      if (sickDaysCollection) {
        // Then filter sickdays that took place within the placement
        sickdays = _.filter(sickDaysCollection.sickDays, sickDay => {
          // filter out sickDates that are started after the enddate of this placement
          if (moment(sickDay.startDate, 'YYYY-MM-DD').isAfter(placementEndDate)) {
            return false;
          }
          // And sickdays that ended before this placement even started
          if (sickDay.endDate && moment(sickDay.endDate, 'YYYY-MM-DD').isBefore(placementStartDate)) {
            return false;
          }
          return true;
        });
      }
      return sickdays;
    },
    getNumberOfSickDaysOfPlacement: () => (sickDays, endPlacementMoment, startPlacementMoment) => {
      let numberOfSickdays = 0;
      if (sickDays) {
        sickDays.forEach(sickDay => {
          let startDateSickDay = moment(sickDay.startDate, 'YYYY-MM-DD').startOf('day');
          let stopDateSickDay = (sickDay.endDate ? moment(sickDay.endDate, 'YYYY-MM-DD') : moment()).endOf('day');
          if (startDateSickDay.isBefore(startPlacementMoment)) {
            startDateSickDay = startPlacementMoment;
          }
          if (stopDateSickDay.isAfter(endPlacementMoment)) {
            stopDateSickDay = endPlacementMoment;
          }
          numberOfSickdays += Math.ceil(moment.duration(stopDateSickDay.diff(startDateSickDay)).asDays());
        });
      }
      return numberOfSickdays;
    },
    getWorkedHoursOfPlacement: (vue) => (placementId, endPlacementMoment, startPlacementMoment) => {
      const durationInWeeks = Math.ceil(moment.duration(endPlacementMoment.diff(startPlacementMoment.startOf('day'))).asWeeks())
      const shouldHaveWorked = durationInWeeks * 38;
      const workedHourDocs = _.filter(vue.getWorkedHoursOfPlacementId(placementId), workedHourDoc => {
        const date = moment().isoWeekYear(workedHourDoc.year).isoWeek(workedHourDoc.weekNumber).startOf('isoWeek');
        if (date.isSameOrAfter(startPlacementMoment, 'week') && date.isSameOrBefore(endPlacementMoment, 'week')) {
          return true;
        } else {
          return false;
        }
      });
      return {
        hasWorked: _.sumBy(workedHourDocs, 'workedHours'), shouldHaveWorked, durationInWeeks
      };
    },
    getCustomerStatistics() {
      const filteredPlacements = _.filter(this.getCustomerPlacements(this.customer.id), placement => {
        console.log("placement", placement)
        // filter out holiday workers
        return !placement.candidateIsHolidayWorker
            &&

            ( // If no end date
                !placement.endDate ||
                // If the end date is beteween the ranges
                moment(placement.endDate, 'YYYY-MM-DD').isBetween(this.picker.startDate, this.picker.endDate, 'date', '[]')
                ||
                // Or if the end date is AFTER the start of the date range
                moment(placement.endDate, 'YYYY-MM-DD').isAfter(this.picker.startDate))
            && (
                // If the start date is beteween the ranges => show it
                moment(placement.startDate, 'YYYY-MM-DD').isBetween(this.picker.startDate, this.picker.endDate, 'date', '[]')
                ||
                // Or if the start date is before the end of the date range
                moment(placement.startDate, 'YYYY-MM-DD').isBefore(this.picker.endDate)
            )
      });
      // Save candidate id's so we can fetch the sick days async
      this.placedCandidates = _.map(filteredPlacements, 'candidateId');

      const returningPlacements = _.map(filteredPlacements, placement => {
        // Moments of start and end of placement (used in multiple calculations)
        const originalStartDateOfPlacement = moment(placement.startDate, 'YYYY-MM-DD').startOf('day');
        const originalEndDateOfPlacement = (placement.endDate ? moment(placement.endDate, 'YYYY-MM-DD') : moment()).endOf('day');
        let startPlacementMoment = originalStartDateOfPlacement.isBefore(this.picker.startDate) ? this.picker.startDate.clone() : originalStartDateOfPlacement;
        let endPlacementMoment = originalEndDateOfPlacement.isAfter(this.picker.endDate) ? this.picker.endDate.clone() : originalEndDateOfPlacement;

        placement.sickDays = this.getSickDaysOfPlacement(placement.candidateId, endPlacementMoment, startPlacementMoment)
        // Count number of sickdays during placement
        placement.numberOfSickdays = this.getNumberOfSickDaysOfPlacement(placement.sickDays, endPlacementMoment, startPlacementMoment)
        // Aantal dagen geplaatst
        placement.duration = startPlacementMoment.startOf('day').isAfter(moment().startOf('day')) ? null : Math.ceil(moment.duration(endPlacementMoment.diff(startPlacementMoment.startOf('day'))).asDays());
        // Add worked hours of placement
        placement.workedHours = this.getWorkedHoursOfPlacement(placement.id, endPlacementMoment, startPlacementMoment);

        // Verhouding ziekte vs geplaatst
        placement.sickVsPlaced = placement.numberOfSickdays ? (placement.numberOfSickdays / placement.duration) : 0;
        return placement;
      });

      // Save the calculated averages to data properties
      // So we dont need to re-calculate all this three times
      this.averagePlacementInDays = _.meanBy(returningPlacements, 'duration');
      this.averageSicknessPerPlacing = _.sumBy(returningPlacements, 'numberOfSickdays') / _.sumBy(returningPlacements, 'duration');
      this.averagePlacementInHoursPercentage = _.sumBy(returningPlacements, 'workedHours.hasWorked') / _.sumBy(returningPlacements, 'workedHours.shouldHaveWorked');
      this.averagePlacementInHoursActualValue = _.sumBy(returningPlacements, 'workedHours.hasWorked');

      return returningPlacements;
    }
    ,
  },
  watch: {
    // Checks new added candidates and fetch their sickday as well
    // But prevents fetching the same docs over and over
    placedCandidates: function (newListOfPlacedCandidateIds, oldListOfPlacedCandidateIds) {
      const newPlacedCandidateIds = _.difference(_.uniq(newListOfPlacedCandidateIds), _.uniq(oldListOfPlacedCandidateIds));
      console.log("newPlacedCandidateIds with uniq", _.difference(_.uniq(newListOfPlacedCandidateIds), _.uniq(oldListOfPlacedCandidateIds)).length)
      console.log("newPlacedCandidateIds without uniq", _.differenceBy(newListOfPlacedCandidateIds, oldListOfPlacedCandidateIds).length)

      newPlacedCandidateIds.forEach(candidateId => {
        this.getSickDay(candidateId).then(sickdays => {
          this.sickDays.push(sickdays)
        })
      });
    }
    ,
    sickdaysToLoad: function (newV, oldV) {
      if (oldV === 0 && newV > 0) {
        this.$store.commit('setLoading', true)
      } else if (oldV > 0 && newV === 0) {
        this.$store.commit('setLoading', false)
      }
    }
  },
  created() {
    this.$store.dispatch('workedHours/openDBChannel', {
      where: [['customerId', '==',
        this.customer.id
      ]],
    });
  },
  beforeDestroy() {
    this.$store.dispatch('workedHours/openDBChannel', {});
  }
}
;
</script>
<style lang="scss" scoped>
.gauges {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}

.print-header {
  display: none;
}

@media print {
  .print-header {
    display: unset;
  }

  .gauges {
    align-items: start;
    align-content: start;
  }
}

</style>
<style>
@media print {
  #m-navbar-top {
    display: none;
  }

  .edit-title-name {
    display: none;
  }

  .customer-page > .row:first-child {
    display: none !important;
  }

  .m-portlet__head {
    display: none !important;
  }

  .edit-information {
    display: none !important;
  }

  .m-sidebar-wrap {
    display: none !important;
  }

  .form-control reportrange-text {
    color: white !important;
  }
}
</style>